import { Component, Inject, Input } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { AnamnesticFieldsResponse } from "../../models";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'se-anamnestic-data-modal',
    templateUrl: './anamnestic-data-modal.component.html',
    styleUrl: './anamnestic-data-modal.component.scss',
    standalone: false
})
export class AnamnesticDataModalComponent {

    @Input() fields : any[] = [];
    @Input() visible : boolean = false;
    anamnesticData : AnamnesticFieldsResponse[] = this.data ?? [];
    anamnesticDataModalForm : FormGroup<any> = new FormGroup({});
    actionSubscripription : Subscription = new Subscription();
    constructor (
        @Inject(MAT_DIALOG_DATA) private data : AnamnesticFieldsResponse[],
        public dialogRef : MatDialogRef<AnamnesticDataModalComponent>,
        private translate : TranslateService
    ) { }

    getTranslatedLabel(index : number) : string {
        return `${this.translate.instant('TitleAnamnesticDataModify')} ${index + 1}`;
    }
}
